import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, Warning } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function ConfirmEmail() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/auth/confirm-email-change", { token })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-6" style={{ background: "var(--app-bg)" }} data-testid="confirm-email-page">
      <div className="sb-card p-8 max-w-sm w-full text-center">
        <Logo className="h-12 mx-auto mb-6" />
        {state === "loading" && <p className="font-heading text-gray-500">…</p>}
        {state === "ok" && (
          <>
            <CheckCircle size={56} weight="fill" className="mx-auto" style={{ color: "#22C55E" }} />
            <p className="font-heading font-semibold text-lg mt-3">{t("emailConfirmed")}</p>
          </>
        )}
        {state === "error" && (
          <>
            <Warning size={56} weight="fill" className="mx-auto" style={{ color: "#EF4444" }} />
            <p className="font-heading font-semibold text-lg mt-3">{t("emailConfirmError")}</p>
          </>
        )}
        <button data-testid="confirm-email-back" onClick={() => navigate("/settings")} className="sb-btn w-full py-3 mt-6 text-white font-medium" style={{ background: "var(--app-primary)" }}>{t("backToApp")}</button>
      </div>
    </div>
  );
}
